import { ecardApi } from './ecardApi';
export { ecardApi };
export default ecardApi;